import Vue from 'vue'

/**
 * directive: 数値を整数にし、３桁区切りの価格表記に修正する
 * <span v-gender="{{ Number }}"></span>
 */
Vue.directive('gender', {
  bind(el, bindings) {
    const { value } = bindings
    let parsed = ''
    if (value === 'F') {
      parsed = '女性'
    } else if (value === 'M') {
      parsed = '男性'
    }
    Object.assign(el, {
      textContent: parsed
    })
  }
})



// WEBPACK FOOTER //
// ./resources/assets/js/directive/gender.js